export default "__VITE_ASSET__DBi_0e$i__"